


























































import { Component, Vue, Watch } from "vue-property-decorator";
import MainNavbar from "./MainNavbar.vue";
import SwitchlangHeader from "./SwitchlangHeader.vue";
import ApplicationStore from "./ApplicationStore.vue";
import DropdownUser from "./DropdownUser.vue";
import SelectCompany from "./SelectCompany.vue";
import { MerchantId } from "@/helper/userHelper";
import SideBar from "./SideBar.vue";
import Notification from "./Notification.vue";
import UserManual from "./UserManual.vue";

@Component({
  components: {
    MainNavbar,
    SwitchlangHeader,
    ApplicationStore,
    DropdownUser,
    SelectCompany,
    SideBar,
    Notification,
    UserManual,
  },
})
export default class Header extends Vue {
  private widthScreen = 0;
  private showSideBar = false;
  private scrollOver = false;
  private lastScrollTop = 0;

  mounted() {
    this.widthScreen = window.innerWidth;
    window.addEventListener("resize", () => {
      this.widthScreen = window.innerWidth;
    });
    window.addEventListener("scroll", this.HandleScroll);
  }

  public HandleScroll() {
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (currentScrollTop > this.lastScrollTop) {
      // downscroll code
      this.scrollOver = false;
    } else if (currentScrollTop < this.lastScrollTop) {
      // upscroll code
      this.scrollOver = window.scrollY > 110;
    }
    this.lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
  }

  @Watch("showSideBar")
  showSideBarChanged(newVal: boolean) {
    if (newVal) {
      this.toggleBodyOverFlow("hidden");
    } else {
      this.toggleBodyOverFlow("auto");
    }
  }

  public toggleBodyOverFlow(overflowType: string) {
    const el = document.body;
    el.style.overflow = overflowType;
  }

  public ToHomePage() {
    this.$router.push({
      name: "home",
      query: { emi: MerchantId().PeakEncryption() },
    });
  }
}
